export default __webpack_public_path__ + "static/media/Ribinfo.6eced89f.png";